export function _documentElement(doc) {
  return doc.documentElement;
}

export function _head(doc) {
  return doc.head;
}

export function _body(doc) {
  return doc.body;
}

export function _readyState(doc) {
  return doc.readyState;
}

export function _visibilityState(doc) {
  return doc.readyState;
}

export function _activeElement(doc) {
  return doc.activeElement;
}

export function _currentScript(doc) {
  return doc.currentScript;
}

export function _referrer(doc) {
  return doc.referrer;
}

export function _title(doc) {
  return doc.title;
}

export function _setTitle(title, doc) {
  doc.title = title;
}
